module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Erreur 404")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("La page que vous cherchez n'est pas disponible ou n'existe plus")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("retourner à l'accueil")])])], 1), _vm._v(" "), _c('video', {
    staticClass: "video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "src": "/static/404.mp4"
    },
    domProps: {
      "muted": true
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9ffd3d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 173
// module chunks = 1